import { render, staticRenderFns } from "./selectList.vue?vue&type=template&id=a18cc542&scoped=true&"
import script from "./selectList.vue?vue&type=script&lang=js&"
export * from "./selectList.vue?vue&type=script&lang=js&"
import style0 from "./selectList.vue?vue&type=style&index=0&id=a18cc542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18cc542",
  null
  
)

export default component.exports